<template>
  <ErrorDialog ref="rootErrorDialog"/>
</template>

<script>
import ErrorDialog from "@/components/ErrorDialog.vue";

export default {
  name: "RootErrorDialog",
  components: {ErrorDialog},
  created() {
    this.$root.$on('showError', this.showError)
  },
  methods: {
    showError: function(options){
      this.$refs.rootErrorDialog.showError(options);
    }
  }
}
</script>